module.exports = __webpack_public_path__ + "static/media/env.1e857d5b.jpg";